export const SAMPLE_START = 'sample/sample-start';
export const SAMPLE_SUCCESS = 'sample/sample-success';
export const SAMPLE_ERROR = 'sample/sample-error';